export default __webpack_public_path__ + "static/media/THRUST.c44951d8.png";